import FormWebhooks from "../FormWebhooks/FormWebhooks";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import { useLocation, useParams } from "react-router-dom";
import "./CadastroWebhooks.css";
import { useEffect, useState } from "react";
import NotificationsService from "../../../services/NotificationsService";

const CadastroWebhooks = () => {
	const { webhookId } = useParams();
	const { state } = useLocation();
	const [webhook, setWebhook] = useState(state);
	const [type, setType] = useState("");

	async function loadWebhook(id) {
		const response = await NotificationsService.getWebhook(id);
		if (response.data) {
			setWebhook(response.data);
		}
	}

	useEffect(() => {
		setType(webhookId || state ? "edicao" : "cadastro");

		if (webhook) {
			setWebhook(state);
			return;
		}

		if (webhookId) {
			loadWebhook(webhookId);
		}
	}, [state, webhookId]);

	return (
		<CadastroContainer>
			<FormWebhooks webhook={webhook} type={type} />
		</CadastroContainer>
	);
};

export default CadastroWebhooks;
